import { withInstall } from '../../utils/install';
import tabs from './src/tabs.vue';

export const Itabs = withInstall(tabs); // 增加类型

export default Itabs;
